<template>
  <div>
    <div class="header">
      <div class="w1200 clearfix">
        <div class="header_l">
          <div style="float:left;margin-right:10px;"><img src="../../assets/led/clogo.png" width="25px" style="vertical-align: middle;"></div>
          欢迎光临志鹏供应链<em><img src="../../assets/led/zp_01.png"> 400-040-7890</em>
        </div>
        <div class="header_r">
          <a href="javascript:;" class="ewm_btn">手机版<em><img src="../../assets/images/qr000.png"></em></a>
          <em v-if="!current_user.id">
            <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
            <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
          </em>
          <em v-else>
            <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
            <a href="javascript:;" class="login_btn" @click="logout">退出</a>
            <router-link :to="{path:'/PersonalData'}" style="color:#fff;">欢迎-{{current_user.name || current_user.tel}}</router-link>
          </em>
        </div>
      </div>
    </div>
    <div class="hxq_ppsp">
      <img src="../../assets/led/kj1.png" height="200px;" width="100%"/>
      <div class="hxq_fllb_sx">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="货柜名称">
                <el-input v-model="form.title" placeholder="请输入货柜名称或编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="行">
                <el-input-number v-model="form.hang" :min="0" :precision="0" label="行" :max="7" @change="importfun"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="列">
                <el-input-number v-model="form.lie" :min="0" :precision="0" label="列" :max="14" @change="changelie" :disabled="importNow"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="柜长(m)">
                <el-input-number v-model="form.meter" :precision="2" :step="0.5" :max="10" :min="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="设备编码">
                <el-input v-model="form.topic" placeholder="请输入设备编码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="相关分组">
                 <el-select v-model="form.groupcab" placeholder="请选择">
                    <el-option
                      v-for="item in groupList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="同侧相关">
                 <el-select v-model="form.same" placeholder="请选择">
                    <el-option
                      v-for="item in sameList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <router-link :to="{path:'/Ledcontrol'}">
              <el-button type="primary" plain>我的仓库</el-button>
            </router-link>
            <el-button type="primary" @click="onSubmitCabinet" plain style="margin-left:15px;">立即创建</el-button>
            <!-- <el-button>取消</el-button> -->
          </el-form-item>
        </el-form>
        <div class="container-data">
          <div class="floor" v-for="(items,floor_index) in lattice" :key="floor_index" :style="'height: ' + 900 / form.hang + 'px;color:#fff'">
            {{floor_index+1}}层
            <div class="thislie" v-for="(item, index) in items.lieList" :key="index" v-show="item.show" :style="'width:' + item.width + 'px;height:' + 760 / form.hang + 'px;line-height:' + 760 / form.hang + 'px'">
              <el-button type="text" @click="open(item,index,floor_index)">合并-{{index+1}}</el-button>
            </div>
            {{floor_index+1}}层
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import api from '@/api/cabinet'
export default {
  name: 'LedcontrolEdit',
  inject: ['reload'], // 注入依赖 实现页面刷新
  data () {
    return {
      return_url: this.$route.fullPath,
      qyloading: false,
      searchSAP: '',
      form: {
        title: '',
        hang: null,
        lie: null,
        meter: 1,
        topic: '',
        groupcab: 1,
        same: 1
      },
      lattice: [], // 表格数据集合
      importNow: true,
      groupList: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }, {
        value: '4',
        label: '4'
      }, {
        value: '5',
        label: '5'
      }, {
        value: '6',
        label: '6'
      }, {
        value: '7',
        label: '7'
      }, {
        value: '8',
        label: '8'
      }, {
        value: '9',
        label: '9'
      }, {
        value: '10',
        label: '10'
      }, {
        value: '11',
        label: '11'
      }, {
        value: '12',
        label: '12'
      }, {
        value: '13',
        label: '13'
      }, {
        value: '14',
        label: '14'
      }, {
        value: '15',
        label: '15'
      }, {
        value: '16',
        label: '16'
      }, {
        value: '17',
        label: '17'
      }, {
        value: '18',
        label: '18'
      }, {
        value: '19',
        label: '19'
      }, {
        value: '20',
        label: '20'
      }],
      sameList: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }]
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getWarehouse()
  },
  methods: {
    importfun (value) {
      if (value > 0) {
        this.importNow = false
      } else if (value <= 0) {
        this.importNow = true
        this.lattice = []
      }
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    open (item, index, floorIndex) {
      this.$prompt('请填写合并数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$message({
          // 合并单元格
          type: 'success',
          message: '合并完成'
        })
        if (item.merge > 1) {
          var num = item.merge - 1 + item.lie
          for (let i = 0; i < value - 1; i++) {
            item.width += this.lattice[floorIndex]['lieList'][num + 1 + i].width
            item.merge += this.lattice[floorIndex]['lieList'][num + 1 + i].merge
            this.lattice[floorIndex]['lieList'][num + 1 + i].show = false
          }
        } else {
          var newNum = 0
          var newMerge = item.merge
          for (let i = 0; i < value - 1; i++) {
            var CND = newMerge + item.lie + newNum
            item.width += this.lattice[floorIndex]['lieList'][CND].width
            item.merge += this.lattice[floorIndex]['lieList'][CND].merge
            this.lattice[floorIndex]['lieList'][CND].show = false
            newNum += this.lattice[floorIndex]['lieList'][CND].merge
          }
        }
      }).catch(() => {
        console.info('取消合并')
        // this.$message({
        //   type: 'info',
        //   message: '取消合并'
        // })
      })
    },
    // 列的生成
    changelie () {
      var hangArray = []
      for (let hang = 0; hang < this.form.hang; hang++) {
        const newhang = { // 每一行
          led: hang, // 灯带编号
          hang: hang,
          lieList: ''
        }
        hangArray.push(newhang)
        var lieArray = []
        for (let i = 0; i < this.form.lie; i++) {
          const latt = { // 格子
            led: hang, // 灯带编号
            hang: hang,
            lie: i,
            lednum: '', // 灯珠编号
            width: 1480 / this.form.lie,
            show: true,
            merge: 1 // 当前格子合并数量，0为未合并
          }
          lieArray.push(latt)
        }
        hangArray[hang]['lieList'] = lieArray
      }
      this.lattice = hangArray
    },
    // 创建柜子
    onSubmitCabinet () {
      if (!this.form.title) {
        this.$message.error('请输入货柜名称或编号')
        return false
      }
      if (!this.form.hang || !this.form.lie) {
        this.$message.error('请输入正确的货柜信息')
        return false
      }
      if (!this.form.topic) {
        this.$message.error('请输入设备编码')
        return false
      }
      api.onSubmitCabinet({ Cabinet: this.form, lattice: this.lattice }).then(res => {
        this.reload()
        this.$message({
          message: '创建成功',
          type: 'success'
        })
      })
    },
    // 仓库信息
    getWarehouse () {
      api.getWarehouse().then(res => {
        this.form.ip = res.item.ip
      })
    }
  }
}
</script>
<style scoped>
.floor{
  width: 100%;
  height: 60px;
  background:url('../../assets/led/banzi.png') no-repeat;
  background-position:bottom;
  display: inline-block;
  background-size: contain;
}
.floor:first-child{
  margin-top:21px;
}
.bgclass{
  background: #fe722c;
}
.mergeable-tr{
  width: 100%;
  background:url('../../assets/led/banzi.png') no-repeat !important;
  background-position:bottom !important;
  background-size: contain !important;
  text-align: center;
}
.vue-mergeable-table{
  /* margin-top: 21px; */
  width: 1600px;
  height: 900px;
  display: inline-table;
}
.container-data{
  width: 1600px;
  height: 933px;
  margin-top:20px;
  background:url('../../assets/led/containerBg.png') no-repeat;
  background-size:cover;
}
.thislie{
  word-wrap:break-word;
  word-break:break-all;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  border-right: 1px solid #ccc;
}
.thislie:first-child{
  margin-left: 47px;
}
.thislie:last-child{
  border:none;
}

.hxq_fllb_sx{
  width: 1600px;
  margin: 0 auto;
  margin-top:30px;
}
.header_l{
  color:#fff;
}
.header_l em{
  color: #fe722c;
}
.header_r a.wddd_btn:hover{
  color:#0f6efd;
}
.header_r a.login_btn:hover{
  color:#0f6efd;
}
.header_r a.ewm_btn:hover{
  color:#0f6efd;
}
.header{
  position: fixed;
  right: 0;
  left: 0;
  background: #29293e;
}
.header_r a{
  color:#b5b5b5;
}
</style>



// WEBPACK FOOTER //
// src/view/led/ledcontrol_edit.vue